const BEAUTY_INSIDER_TAB_KEYS = {
    REWARDS: 'Rewards',
    EARN_POINTS: 'EarnPoints',
    BENEFITS: 'Benefits',
    HISTORY: 'History'
};

const HISTORY_USER_STATES = {
    GUEST: 'guest',
    NON_BI: 'nonBi',
    EMPTY_BI: 'emptyBi',
    INSIDER: 'insider'
};

const HISTORY_SECTION_STATUS = {
    LOADING: 'loading',
    PLACEHOLDER: 'placeholder',
    EMPTY: 'empty',
    POPULATED: 'populated',
    ERROR: 'error'
};

const HISTORY_CARD_STYLES = {
    GREY: 'grey',
    WHITE: 'white'
};

const HISTORY_ROUTES = {
    SHOP_NOW: '/'
};

export {
    BEAUTY_INSIDER_TAB_KEYS, HISTORY_CARD_STYLES, HISTORY_ROUTES, HISTORY_SECTION_STATUS, HISTORY_USER_STATES
};
